import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetMdrCharges } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const FetchMdrCharges = createAsyncThunk('get/fetchMdrCharges', GetMdrCharges);

export const GetMdrChargesSlice = createSlice({
	name: 'getMdrCharges',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[FetchMdrCharges.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[FetchMdrCharges.rejected.toString()]: setAPIError,
		[FetchMdrCharges.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[GetMdrChargesSlice.name]: ReturnType<typeof GetMdrChargesSlice.reducer>;
}

export const getMdrChargesSelector = (state: IStates): any => {
	return state[GetMdrChargesSlice.name] || {};
};

export const useGetMdrCharges = (): any => useSelector(getMdrChargesSelector);

export const triggerGetMdrCharges =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchMdrCharges(params));
		return;
	};

export const resetGetMdrCharges =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(GetMdrChargesSlice.actions.RESET());
		return;
	};
